import { createApiSlice } from "@common";
import { CRUD_CAMPAIGN_CATEGORY } from "@routes";

const apiConfig = [
  {
    name: "addCampaignCategory",
    method: "post",
    url: CRUD_CAMPAIGN_CATEGORY,
    stateKey: "message",
  },
  {
    name: "getCampaignCategory",
    method: "get",
    url: CRUD_CAMPAIGN_CATEGORY,
    stateKey: "data",
  },
  {
    name: "updateCampaignCategory",
    method: "put",
    url: CRUD_CAMPAIGN_CATEGORY,
    stateKey: "message",
  },
  {
    name: "deleteCampaignCategory",
    method: "delete",
    url: CRUD_CAMPAIGN_CATEGORY,
    stateKey: "message",
  },
];

const customReducers = {
  initialState: {
    data: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
"campaignCategory",
 apiConfig, 
 customReducers);
const campaignCategorySlice = slice;

export default campaignCategorySlice.reducer;

export const {
  addCampaignCategory,
  getCampaignCategory,
  updateCampaignCategory,
  deleteCampaignCategory,
} = thunks;

export const { rowSelect } = actions;
